import { apolloClient } from "@td/ui";
import NP_COORDINATION_ITEMS_QUERY from '../queries/query_np_coordination_items.graphql';

const queryNpCoordinationItems = async (filters, page) => {
  const { data: { npCoordinationItems } } = await apolloClient.query({
    query: NP_COORDINATION_ITEMS_QUERY,
    fetchPolicy: 'network-only',
    variables: {
      ...filters,
      page: page
    }
  });

  return npCoordinationItems;
};

export default queryNpCoordinationItems;
